import debounce from 'debounce';

export default class MegaNav {
  constructor({ el }) {
    this.el = el;
    this.parent = this.el.parentElement;
    this.meganavWrapper = this.el.querySelector('.navmenu-meganav-wrapper');
    this.promoContainer = this.el.querySelector('.meganav-promo-container');

    this.resize = () => {
      debounce(this.sizeSubmenuColumn(), 200);
    };

    this.fixContentSizing = () => {
      this.sizeSubmenuColumn();
    };

    this.sizeSubmenuColumn();

    window.addEventListener('resize', this.resize);
    this.parent.addEventListener('touchend', this.fixContentSizing);
    this.parent.addEventListener('mouseover', this.fixContentSizing);
    this.parent.addEventListener('focusin', this.fixContentSizing);
  }

  sizeSubmenuColumn() {
    const columns = this.el.querySelectorAll('.navmenu-meganav-depth-2 > .navmenu-meganav-item');
    const firstColumn = columns[0];
    const firstTop = firstColumn.getBoundingClientRect().top + 20;
    const firstWidth = firstColumn.offsetWidth;

    for (let i = 0; i < columns.length; i++) {
      const columnTop = columns[i].getBoundingClientRect().top;
      if (firstTop < columnTop) {
        columns[i].style.maxWidth = `${firstWidth}px`;
      } else {
        columns[i].style.maxWidth = '';
      }
    }
  }

  unload() {
    window.removeEventListener('resize', this.resize);
    this.parent.removeEventListener('touchend', this.fixContentSizing);
    this.parent.removeEventListener('mouseover', this.fixContentSizing);
    this.parent.removeEventListener('focusin', this.fixContentSizing);
  }
}
